(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'navigationTabs', {
            templateUrl:  'app/views/partials/layout/navigation-tabs.html',
            controller:   NavigationTabsController,
            controllerAs: 'vm'
        });


    /**
     * Prepares subnavigation model based on parent state's children
     * OR list of given states.
     *
     * @param {ng.IScope} $scope
     * @param {uirouter.State} $state
     * @param {LoggerFactory} LoggerFactory
     * @param {SubpagesService} SubpagesService
     * @param {AutoscrollService} AutoscrollService
     * @param {Object} TEXTS
     */
    function NavigationTabsController(
        $scope,
        $state,
        LoggerFactory,
        SubpagesService,
        AutoscrollService,
        TEXTS
    ){
        // Helper members.

        /** @type {angular.IController} */
        var vm = this;

        LoggerFactory.createLogger( 'NavigationTabsController' );


        /** Expose to the Scope. */
        $scope._ = TEXTS.GENERIC.NAVIGATION_TABS;


        /** Expose to the Controller */
        vm.scrollToTop = scrollToTop;



        /** @constructor */
        function init(){
            // Members (+ their defaults)
            vm.navigationItems  = [];
            vm.state            = $state;

            setWatchers();
        };

        /** Run right after all the bindings are ready! */
        vm.$onInit = init;





        /* ===== PUBLIC METHODS ============================================= */


        function scrollToTop() {
            AutoscrollService.scrollTo( 0 );
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function setWatchers() {
            // One-time binding watch
            var subpagesListenerDeregistration = $scope.$watch(
                function() {
                    return SubpagesService.currentSubpages;
                },
                /**
                 * @param {uirouter.StateDeclaration[]}
                 */
                function( newSubpages ) {
                    if ( newSubpages ) {
                        vm.navigationItems = newSubpages;
                        subpagesListenerDeregistration();
                    }
                }
            );
        }
    }


    NavigationTabsController.$inject = [ '$scope', '$state', 'LoggerFactory', 'SubpagesService', 'AutoscrollService', 'TEXTS' ];
})();
